jQuery_T4NT(document).ready(function($) {

  /**
   *  Variant selection changed (zostawiam, jak było)
   */
  $(document).on("variant:changed", function(evt) {
    // console.log(evt.currentVariant);
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

  /**
   * ✅ Ustawienia stylu dla ikony czatu (#ShopifyChat)
   */
  const chat = document.getElementById('ShopifyChat');
  if (chat) {
    chat.style.zIndex = '466';
  }

});
